import { Component } from '@angular/core';
import { environment } from '../../../../../environments/environment';

@Component({
  standalone: false,
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
})
export class NotFoundComponent {
  public CDN_URL: string = environment.CDN_URL;
  constructor() {}
}
